import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
class RadioButtonComponent {
    constructor() {
        /** When multiple radio input fields are used
         * an "id" can be given to keep track of them */
        this.id = "";
        /** Name of the attribute for which the radio
         * selection is provided */
        this.name = "";
        /** Value of the attribute which is to be emitted
         * when selected */
        this.value = "";
        /** Controls the state of the radio button */
        this.disabled = false;
        /** Can be used to attach the radio input field
         * to a reactive form by passing in a
         * “FormControl“ Object. It can also be
         * used to set the default attribute value */
        this.formControl = new FormControl(null);
        /** Emits "value" of the radio button on selection */
        this.valueChange = new EventEmitter();
    }
    ngOnInit() { }
    onChange(event) {
        this.valueChange.emit(this.formControl.value);
    }
}
RadioButtonComponent.ɵfac = function RadioButtonComponent_Factory(t) { return new (t || RadioButtonComponent)(); };
RadioButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioButtonComponent, selectors: [["mis-radio"]], inputs: { id: "id", name: "name", value: "value", disabled: "disabled", formControl: "formControl" }, outputs: { valueChange: "valueChange" }, decls: 1, vars: 5, consts: [["type", "radio", 3, "id", "name", "disabled", "value", "formControl", "change"]], template: function RadioButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0);
        ɵngcc0.ɵɵlistener("change", function RadioButtonComponent_Template_input_change_0_listener($event) { return ctx.onChange($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("id", ctx.id);
        ɵngcc0.ɵɵproperty("name", ctx.name)("disabled", ctx.disabled)("value", ctx.value)("formControl", ctx.formControl);
    } }, dependencies: [ɵngcc1.DefaultValueAccessor, ɵngcc1.RadioControlValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlDirective], styles: ["input[type=radio][_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;width:20px;height:20px;margin:0;padding:3px;background-clip:content-box;border:2px solid #6a737d;background-color:#fff;border-radius:50%;cursor:pointer}input[type=radio][_ngcontent-%COMP%]:checked{background-color:#0937b2;border:2px solid #0937b2}input[type=radio][_ngcontent-%COMP%]:hover{border:2px solid #929dab}input[type=radio][_ngcontent-%COMP%]:checked:hover{border:2px solid #0937b2}input[type=radio][_ngcontent-%COMP%]:disabled{border:2px solid #c8cdd3}input[type=radio][_ngcontent-%COMP%]:checked:disabled{border:2px solid #c8cdd3;background-color:#c8cdd3}"] });
RadioButtonComponent.ctorParameters = () => [];
RadioButtonComponent.propDecorators = {
    id: [{ type: Input }],
    name: [{ type: Input }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    formControl: [{ type: Input }],
    valueChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioButtonComponent, [{
        type: Component,
        args: [{ selector: "mis-radio", template: "<input (change)=\"onChange($event)\" id=\"{{ id }}\" type=\"radio\" [name]=\"name\" [disabled]=\"disabled\" [value]=\"value\" [formControl]=\"formControl\" />\n", styles: ["input[type=radio]{-webkit-appearance:none;-moz-appearance:none;appearance:none;width:20px;height:20px;margin:0;padding:3px;background-clip:content-box;border:2px solid #6a737d;background-color:#fff;border-radius:50%;cursor:pointer}input[type=radio]:checked{background-color:#0937b2;border:2px solid #0937b2}input[type=radio]:hover{border:2px solid #929dab}input[type=radio]:checked:hover{border:2px solid #0937b2}input[type=radio]:disabled{border:2px solid #c8cdd3}input[type=radio]:checked:disabled{border:2px solid #c8cdd3;background-color:#c8cdd3}"] }]
    }], function () { return []; }, { id: [{
            type: Input
        }], name: [{
            type: Input
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }], formControl: [{
            type: Input
        }], valueChange: [{
            type: Output
        }] }); })();

class RadioButtonModule {
    static forRoot() {
        return { ngModule: RadioButtonModule, providers: [] };
    }
}
RadioButtonModule.ɵfac = function RadioButtonModule_Factory(t) { return new (t || RadioButtonModule)(); };
RadioButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: RadioButtonModule });
RadioButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, ReactiveFormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [RadioButtonComponent],
                imports: [CommonModule, ReactiveFormsModule],
                exports: [RadioButtonComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RadioButtonModule, { declarations: function () { return [RadioButtonComponent]; }, imports: function () { return [CommonModule, ReactiveFormsModule]; }, exports: function () { return [RadioButtonComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { RadioButtonComponent, RadioButtonModule };

